import LibFade from 'react-reveal/Fade';

export const Fade = ({ children, when }) => <LibFade bottom when={when}>{children}</LibFade>;
